/**
 *
 * 自定义线条箭头
 */

export default {
  startArrow: {},
  endArrow: {}
}
